import { triniumApi } from '@api/Trinium/slice';
import { Hub } from './types';

const hubsSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchHubs: builder.query<Hub[], string>({
				query: (terminalNumber) => ({
					url: `/${terminalNumber}/hubs`
				}),
				keepUnusedDataFor: Number.MAX_VALUE
			})
		};
	}
});

export const { useFetchHubsQuery } = hubsSlice;
